
const startParticleSystem = (
    id,
    initX,
    initY,
    color = { r: 255, g: 255, b: 255 },
    direction = "up",
    systemArray,
    options = {},
    metadata = {}
  ) => {
    const particles = [];
    const initTtl = options.initTtl || 50;
    const initSize = options.initSize || 6;
    const maxParticles = options.maxParticles || 10;
    const speed = options.speed || 1;
    const once = options.once || false;
    const headParticleColor = options.headParticleColor;
    const systemSpeed = options.systemSpeed || 6;
    particles.push({
      x: initX + Math.random() * 10,
      y: initY,
      ttl: initTtl,
      opacity: 1,
      size: initSize,
    });
    systemArray.push({
      init: {
        color,
        direction,
        headParticleColor,
        id,
        initX,
        initY,
        initTtl,
        initSize,
        maxParticles,
        once,
        speed,
        systemSpeed,
        metadata
      },
      particles,
    });
  };
  
  const updateParticleSystems = (systemArray) => {
    if (state === STATES.RUNNING || state === STATES.TITLE) {
      systemArray.forEach((system) => {
        const {
          initX,
          initY,
          initTtl,
          initSize,
          maxParticles,
          color,
          direction,
          speed,
          once,
          headParticleColor
        } = system.init;
        system.particles.forEach((p, index) => {
          if (!p.dead) {
            let { x, y, size } = p;
            ctx.clearRect(x, y, size, size);
            let newP = { ...p };
            ctx.fillStyle = `rgba(${color.r}, ${color.g}, ${color.b}, ${newP.opacity})`;
            ctx.fillRect(x, y, size, size);
            newP.ttl -= 1;
            const rand = getNextRandomValue();
            if (newP.ttl > 0) {
              if (direction === "up") {
                newP.x += rand * 2 - 1;
                newP.y -= speed;
              } else if (direction === "down") {
                newP.x += rand * 2 - 1;
                newP.y -= -speed;
              } else if (direction === "left") {
                newP.x += -speed;
                newP.y -= rand * 2 - 1;
              } else if (direction === "right") {
                newP.x += speed;
                newP.y -= rand * 2 - 1;
              } else if (direction === "up left") {
                newP.x -= speed / 2;
                newP.y -= speed / 2;
              } else if (direction === "up right") {
                newP.x += speed / 2;
                newP.y -= speed / 2;
              } else if (direction === "down left") {
                newP.x -= speed / 2;
                newP.y += speed / 2;
              } else if (direction === "down right") {
                newP.x += speed / 2;
                newP.y += speed / 2;
              }
              newP.opacity -= 1 / initTtl;
              newP.size -= initSize / initTtl;
            } else if (once) {
              newP.opacity = 0;
              newP.dead = true;
            } else {
              newP.x = initX;
              newP.y = initY;
              newP.ttl = initTtl + Math.floor(rand * 20);
              newP.opacity = 1;
              newP.size = initSize;
            }
            system.particles[index] = newP;
          }
        });
        if (headParticleColor) {
          ctx.fillStyle = headParticleColor;
          ctx.shadowColor = headParticleColor;
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = 0;
          ctx.shadowBlur = 10;
          ctx.fillRect(initX, initY, initSize, initSize);
          ctx.shadowBlur = 0;
        }
        if (system.particles.length < maxParticles) {
          system.particles.push({
            x: initX + Math.random() * 10,
            y: initY,
            opacity: 1,
            size: 5,
          });
        }
      });
    }
  };
  
  const removeParticleSystem = (index, systemArray) => {
    delete systemArray[index];
    systemArray = systemArray.filter((e) => e);
  };
  